import { render } from "./Type1.vue?vue&type=template&id=77d2b992"
import script from "./Type1.vue?vue&type=script&lang=ts"
export * from "./Type1.vue?vue&type=script&lang=ts"
script.render = render

export default script